import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Attorney Profiles',
    href: '#attorney'
  }, {
    name: 'Practice Areas',
    href: '#practice-areas'
  }, {
    name: 'Contact Us',
    href: '#contact'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 flex flex-col" data-id="element-111">
      {/* Top Utility Bar */}
      <div className="bg-[#7c0a0a] text-white py-2 px-4 md:px-8 flex flex-wrap justify-center md:justify-end items-center gap-x-2 text-xs sm:text-sm md:text-base" data-id="element-112">
        <span className="font-medium" data-id="element-113">Call Us Today!</span>
        <a href="tel:469-713-6764" className="font-bold text-base sm:text-lg hover:text-[#c9a35a] transition-colors" data-id="element-114">
          469-713-6764
        </a>
      </div>

      {/* Main Navigation */}
      <div className={`transition-all duration-300 ${isScrolled ? 'bg-[#1a1a1a]/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'} px-4 md:px-8`} data-id="element-115">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-116">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-2.5 sm:gap-4 group min-w-0" data-id="element-117">
            <div className="w-11 h-11 sm:w-12 sm:h-12 md:w-14 md:h-14 shrink-0 rounded-full border-2 border-[#c9a35a] flex items-center justify-center bg-[#1a1a1a] group-hover:bg-[#c9a35a] transition-colors duration-300" data-id="element-118">
              <span className="font-serif text-lg sm:text-xl md:text-2xl font-bold text-[#c9a35a] group-hover:text-[#1a1a1a] transition-colors duration-300" data-id="element-119">
                MS
              </span>
            </div>
            <div className="flex flex-col min-w-0" data-id="element-120">
              <span className="text-gray-300 text-[10px] sm:text-xs md:text-sm uppercase tracking-[0.15em] sm:tracking-widest" data-id="element-121">
                The Law Office of
              </span>
              <span className="font-serif text-white text-sm sm:text-lg md:text-2xl font-bold leading-tight truncate" data-id="element-122">
                MICHAEL STUFFLEBEAM{' '}
                <span className="text-xs sm:text-sm font-normal text-[#c9a35a]" data-id="element-123">
                  ESQ.
                </span>
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-124">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white font-medium text-sm hover:text-[#c9a35a] transition-colors" data-id="element-125">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-126">
            {isMobileMenuOpen ? <X size={28} data-id="element-127" /> : <Menu size={28} data-id="element-128" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-129">
        {isMobileMenuOpen && <motion.nav initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-[#1a1a1a] border-t border-gray-800 overflow-hidden" data-id="element-130">
            <div className="flex flex-col px-4 py-4 space-y-4" data-id="element-131">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white font-medium text-lg hover:text-[#c9a35a] transition-colors block py-2 border-b border-gray-800" data-id="element-132">
                  {link.name}
                </a>)}
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}